<template lang="html">
   <div class="label">
      <label>{{label}}</label>
   </div>
</template>

<script>
export default {
   props: {
      label: {
         default: ''
      }
   },
}
</script>

<style lang="less"></style>